import { api } from "./api";
import { IRegulation } from "./regulation.service";

export async function getRegulationSimplify() {
  const { data } = await api.get<IRegulation[]>(`database/regulamento_simplifique__c`);
  if (Array.isArray(data)) {
    return data[0] as any;
  } else {
    return null;
  }
}